import { render, staticRenderFns } from "./PanelOnHover.vue?vue&type=template&id=befd8a5a"
import script from "./PanelOnHover.vue?vue&type=script&lang=js"
export * from "./PanelOnHover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports